// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsAttributionRelativeAppModule } from './app.module';
bootstrapAppModule(MutualFundsAttributionRelativeAppModule);
